export enum UserTableColumn {
  NOMINA = 'nomina',
  NOMBRE = 'nombre',
  ES_ADMIN = 'rol',
  ACTIVO = 'estatus',
}
